import { get, post } from './api';

export const xdSms = params =>
  get(
    '/aikucun-community-operate/payShop/sendSms',
    params,
    {},
    false
  );

export const xdLogin = params =>
  get(
    '/aikucun-community-operate/payShop/login',
    params,
    {},
    false
  );

export const xdParter = params =>
  post(
    '/aikucun-community-operate/payShop/addPartner',
    params,
    {},
    false
  );


export const xdParterOrder= params =>
  post(
    '/aikucun-community-operate/payShop/getPayShopOrder',
    params,
    {},
    false
  );

export const xdParterOrderList = params =>
  post(
    '/aikucun-community-operate/payShop/getPayShopOrderList',
    params,
    {},
    false
  );

export const getGodds = params =>
  get (
    '/aikucun-community-operate/productInfo/queryProduct',
    params
  );

export const prePayOrder = params =>
  post (
    '/aikucun-community-operate/link/getPrePayInfoByPayType',
    params,
    {},
    false
  );

export const xdOrderState = params =>
  get(
    '/aikucun-community-operate/link/getOrderState',
    params,
    {},
    false
  );

export const xdRefreshToken = params =>
  get(
    '/akucun-member-center/member/imUser/forceRefreshToken',
    params,
    {},
    false
  );

export const xdHasShop = params =>
  get(
    '/aikucun-community-operate/payShop/checkXD',
    params,
    {},
    false
  );

export const getBarCode = params =>
  post(
    '/aikucun-community-operate/program/get_bar_code',
    params,
    {},
    false
  );